"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.push.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _validate = require("@/utils/validate");
var _queue = require("@/api/queue");
let RecoverPassword = class RecoverPassword extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.recoveryForm = {
      email: ''
    };
    this.loading = false;
    this.validateEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Email is required'));
      } else if (!(0, _validate.isValidEmail)(value)) {
        callback(new Error('Please enter a valid email'));
      } else {
        callback();
      }
    };
    this.recoveryRules = {
      email: [{
        validator: this.validateEmail,
        trigger: 'blur'
      }]
    };
  }
  handleRecover() {
    this.$refs.recoveryForm.validate(async valid => {
      if (!valid) return;
      this.loading = true;
      try {
        await (0, _queue.sendRecoveryMail)(this.recoveryForm);
        this.$notify({
          title: 'Success',
          message: 'Recovery email sent successfully',
          type: 'success',
          duration: 2000
        });
        this.$router.push('/login');
      } catch (error) {
        this.$notify.error({
          title: 'Error',
          message: 'Failed to send recovery email'
        });
      } finally {
        this.loading = false;
      }
    });
  }
};
RecoverPassword = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'RecoverPassword'
})], RecoverPassword);
var _default = exports.default = RecoverPassword;